(() => {
  'use strict';
  const config = document.getElementById('ODQuickStrings');
  if (!config) return;
  const text = JSON.parse(config.textContent);
  const pending = new Set();
  let notice;
  function announce(message, error = false) {
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'odq-notice';
      const status = document.createElement('p');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      const link = document.createElement('a');
      link.href = text.cart;
      link.textContent = text.view;
      const close = document.createElement('button');
      close.type = 'button';
      close.textContent = '×';
      close.setAttribute('aria-label', text.close);
      close.addEventListener('click', () => { notice.hidden = true; });
      notice.append(status, link, close);
      document.body.append(notice);
    }
    notice.hidden = false;
    notice.classList.toggle('is-error', error);
    notice.querySelector('p').textContent = message;
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-od-quick-form]');
    if (!form) return;
    event.preventDefault();
    const id = new FormData(form).get('id');
    if (pending.has(id)) return;
    const button = form.querySelector('button');
    const label = button.querySelector('span');
    const original = label.textContent;
    pending.add(id);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = text.adding;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = new FormData(form);
    if (cart?.getSectionsToRender) {
      body.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
      body.append('sections_url', location.pathname);
      cart.setActiveElement?.(button);
    }
    try {
      const response = await fetch(text.add_url + '.js', { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || text.error);
      label.textContent = text.added;
      if (notice) notice.hidden = true;
      if (cart?.renderContents) {
        try {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } catch {
          location.assign(text.cart);
        }
      } else {
        location.assign(text.cart);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'od-quick-add', productVariantId: id, cartData: result});
      }
    } catch (error) {
      announce(error.message || text.error, true);
    } finally {
      pending.delete(id);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = original;
    }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-od-quick-primary]');
    if (!button) return;
    const product = button.closest('[data-od-product]');
    const primary = product?.querySelector('[data-add]');
    if (!primary || primary.disabled || product.querySelector('[data-access-required][hidden]')) return;
    product.querySelector('.odp-product-form')?.requestSubmit();
  });
})();

(() => {
const key='od_saved_pieces_v1';
const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'[]').filter(p=>p&&p.id&&typeof p.url==='string');}catch{return [];}};
const update=()=>{const saved=read();document.querySelectorAll('[data-od-card-save]').forEach(b=>{try{const p=JSON.parse(b.dataset.piece);const on=saved.some(s=>s.id===p.id);b.setAttribute('aria-pressed',String(on));b.setAttribute('aria-label',(on?'Remove from saved bags: ':'Save ')+p.title);}catch{}});};
document.addEventListener('click',e=>{const b=e.target.closest('[data-od-card-save]');if(!b)return;e.preventDefault();try{const p=JSON.parse(b.dataset.piece),saved=read(),on=saved.some(s=>s.id===p.id);localStorage.setItem(key,JSON.stringify(on?saved.filter(s=>s.id!==p.id):[p,...saved]));update();}catch{b.setAttribute('aria-label','Unable to save. Please allow browser storage.');}});
addEventListener('storage',update);document.addEventListener('shopify:section:load',update);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update,{once:true});else update();
new MutationObserver(update).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
})();
